import React from "react";


import Carousel from "react-elastic-carousel"
import Item from "../components/Item"

import systemsStyles from "../styles/components/systems.module.scss";

import introStyles from "../styles/components/index.module.scss";

    const systemsCarousel = () => {
        return (
            <div className={introStyles.systemsSlider}>
                <div className={systemsStyles.systemsSlider} id="systems">
                    <h1>OS</h1>
                    <div className={systemsStyles.systemsItems}>
                        <Carousel >
                            <Item className={systemsStyles.linux}></Item>
                            <Item className={systemsStyles.windows}></Item>
                            <Item className={systemsStyles.windowsServer}></Item>
                        </Carousel>
                    </div> 
                </div>
            </div>
        )
    }

export default systemsCarousel;